import { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid-pro';
import { dataGridCol } from '@shared/components/grid/common';
import { deCamelize } from '@shared/commonFunctions';

export const useLenderELTEditorColumns = () => {
  const columns = useMemo<GridColDef[]>(
    () => [
      dataGridCol('name', {
        flex: 1.5,
        headerName: 'Lender',
        minWidth: 120,
      }),
      dataGridCol('state', {
        flex: 0.7,
        headerName: 'For State Of',
        minWidth: 80,
        renderCell: (params) => params.value && deCamelize(params.value),
      }),
      dataGridCol('eltCode', {
        editable: true,
        flex: 1.3,
        headerName: 'ELT Code',
        maxWidth: undefined,
        minWidth: 100,
      }),
      dataGridCol('lenderName', {
        editable: true,
        flex: 2,
        headerName: 'Lender Name',
        maxWidth: undefined,
        minWidth: 100,
      }),
      dataGridCol('lenderAddress', {
        editable: true,
        flex: 2,
        headerName: 'Address',
        maxWidth: undefined,
        minWidth: 120,
      }),
      dataGridCol('lenderState', {
        editable: true,
        flex: 0.7,
        headerName: 'State',
        maxWidth: undefined,
        minWidth: 80,
      }),
      dataGridCol('lenderCity', {
        editable: true,
        flex: 1.4,
        headerName: 'City',
        maxWidth: undefined,
        minWidth: 100,
      }),
      dataGridCol('lenderPostCode', {
        editable: true,
        flex: 0.5,
        headerName: 'Zip',
        maxWidth: undefined,
        minWidth: 80,
      }),
    ],
    [],
  );

  return { columns };
};
